// Aggregate sample reporting data for the interactive Insights prototype.
// Campaign spend is entered demo data. Attendance and visit value are derived
// from the fictional reporting snapshot, not from a live advertising account.

const PERIODS = {
  day: {
    id: "day",
    label: "Today",
    range: "Today, through 16:00",
    comparison: "Previous comparable day",
    status: "In progress",
    enquiries: 8,
    previousEnquiries: 11,
    bookings: 4,
    dueBookings: 4,
    attended: 3,
    noShows: 1,
    rebooked: 0,
    visitValue: 471,
    previousVisitValue: 540,
    averageFirstVisit: 157,
    followupEligible: 1,
    followupRate: 0.32,
    reallocationBudget: 0,
    trend: [
      { label: "10:00", current: 0, previous: 0 },
      { label: "11:30", current: 120, previous: 160 },
      { label: "13:00", current: 120, previous: 310 },
      { label: "14:30", current: 311, previous: 420 },
      { label: "16:00", current: 471, previous: 540 },
    ],
    // Intermediate points are explicit demo snapshots. The final point always
    // reconciles to the aggregate counts above, so the chart never implies a
    // more precise operational history than this prototype contains.
    metricTrend: [
      { label: "10:00", showRate: 0, bookingRate: 25 },
      { label: "11:30", showRate: 50, bookingRate: 33.3 },
      { label: "13:00", showRate: 50, bookingRate: 37.5 },
      { label: "14:30", showRate: 66.7, bookingRate: 42.9 },
      { label: "16:00", showRate: (3 / 4) * 100, bookingRate: (4 / 8) * 100 },
    ],
    acquisitionTrend: [
      { label: "10:00", spend: 8, attendedValue: 0, attended: 0, costPerAttended: 0, campaignReturn: 0, showRate: 0 },
      { label: "11:30", spend: 20, attendedValue: 0, attended: 0, costPerAttended: 0, campaignReturn: 0, showRate: 0 },
      { label: "13:00", spend: 34, attendedValue: 85, attended: 1, costPerAttended: 34, campaignReturn: 2.5, showRate: 50 },
      { label: "14:30", spend: 47, attendedValue: 85, attended: 1, costPerAttended: 47, campaignReturn: 1.8, showRate: 50 },
      { label: "16:00", spend: 58, attendedValue: 335, attended: 2, costPerAttended: 58 / 2, campaignReturn: 335 / 58, showRate: (2 / 3) * 100 },
    ],
    campaigns: [
      { id: "whitening", name: "Whitening carousel", channel: "Instagram", format: "Carousel", delivery: "Active", spend: 18, enquiries: 5, booked: 1, attended: 0, value: 0 },
      { id: "implant", name: "Implant consultation video", channel: "Facebook", format: "Video", delivery: "Active", spend: 28, enquiries: 4, booked: 1, attended: 1, value: 250 },
      { id: "checkup", name: "Check-up reminder post", channel: "Facebook", format: "Static post", delivery: "Paused", spend: 12, enquiries: 3, booked: 1, attended: 1, value: 85 },
    ],
  },
  week: {
    id: "week",
    label: "7 days",
    range: "14 to 20 August 2026",
    comparison: "7 to 13 August 2026",
    status: "Closed period",
    enquiries: 51,
    previousEnquiries: 44,
    bookings: 22,
    dueBookings: 22,
    attended: 16,
    noShows: 6,
    rebooked: 2,
    visitValue: 2512,
    previousVisitValue: 2210,
    averageFirstVisit: 157,
    followupEligible: 4,
    followupRate: 0.32,
    reallocationBudget: 100,
    trend: [
      { label: "Mon", current: 290, previous: 250 },
      { label: "Tue", current: 610, previous: 530 },
      { label: "Wed", current: 980, previous: 810 },
      { label: "Thu", current: 1340, previous: 1140 },
      { label: "Fri", current: 1700, previous: 1480 },
      { label: "Sat", current: 2070, previous: 1840 },
      { label: "Sun", current: 2512, previous: 2210 },
    ],
    metricTrend: [
      { label: "Mon", showRate: 66.7, bookingRate: 37.5 },
      { label: "Tue", showRate: 62.5, bookingRate: 40 },
      { label: "Wed", showRate: 70, bookingRate: 41.7 },
      { label: "Thu", showRate: 69.2, bookingRate: 43.3 },
      { label: "Fri", showRate: 71.4, bookingRate: 44.1 },
      { label: "Sat", showRate: 73.7, bookingRate: 43.2 },
      { label: "Sun", showRate: (16 / 22) * 100, bookingRate: (22 / 51) * 100 },
    ],
    acquisitionTrend: [
      { label: "Mon", spend: 60, attendedValue: 250, attended: 1, costPerAttended: 60, campaignReturn: 4.2, showRate: 66.7 },
      { label: "Tue", spend: 125, attendedValue: 250, attended: 2, costPerAttended: 62.5, campaignReturn: 2, showRate: 50 },
      { label: "Wed", spend: 200, attendedValue: 585, attended: 4, costPerAttended: 50, campaignReturn: 2.9, showRate: 60 },
      { label: "Thu", spend: 275, attendedValue: 925, attended: 6, costPerAttended: 45.8, campaignReturn: 3.4, showRate: 62.5 },
      { label: "Fri", spend: 350, attendedValue: 1250, attended: 8, costPerAttended: 43.8, campaignReturn: 3.6, showRate: 60 },
      { label: "Sat", spend: 420, attendedValue: 1580, attended: 9, costPerAttended: 46.7, campaignReturn: 3.8, showRate: 61 },
      { label: "Sun", spend: 475, attendedValue: 1887, attended: 11, costPerAttended: 475 / 11, campaignReturn: 1887 / 475, showRate: (11 / 19) * 100 },
    ],
    campaigns: [
      { id: "whitening", name: "Whitening carousel", channel: "Instagram", format: "Carousel", delivery: "Active", spend: 125, enquiries: 36, booked: 6, attended: 2, value: 296 },
      { id: "braces", name: "Braces reel", channel: "Instagram", format: "Reel", delivery: "Active", spend: 110, enquiries: 18, booked: 4, attended: 2, value: 336 },
      { id: "implant", name: "Implant consultation video", channel: "Facebook", format: "Video", delivery: "Active", spend: 150, enquiries: 22, booked: 5, attended: 4, value: 1000 },
      { id: "checkup", name: "Check-up reminder post", channel: "Facebook", format: "Static post", delivery: "Paused", spend: 90, enquiries: 22, booked: 4, attended: 3, value: 255 },
    ],
  },
  month: {
    id: "month",
    label: "30 days",
    range: "1 to 31 July 2026",
    comparison: "1 to 30 June 2026",
    status: "Closed period",
    enquiries: 214,
    previousEnquiries: 186,
    bookings: 96,
    dueBookings: 96,
    attended: 67,
    noShows: 29,
    rebooked: 8,
    visitValue: 10531,
    previousVisitValue: 8974,
    averageFirstVisit: 157,
    followupEligible: 18,
    followupRate: 0.32,
    reallocationBudget: 400,
    trend: [
      { label: "1 Jul", current: 0, previous: 0 },
      { label: "5 Jul", current: 1260, previous: 1100 },
      { label: "10 Jul", current: 2940, previous: 2350 },
      { label: "15 Jul", current: 4525, previous: 3670 },
      { label: "20 Jul", current: 6550, previous: 5340 },
      { label: "25 Jul", current: 8340, previous: 7040 },
      { label: "31 Jul", current: 10531, previous: 8974 },
    ],
    metricTrend: [
      { label: "1 Jul", showRate: 0, bookingRate: 0 },
      { label: "5 Jul", showRate: 66.7, bookingRate: 40 },
      { label: "10 Jul", showRate: 68.2, bookingRate: 42.5 },
      { label: "15 Jul", showRate: 67.6, bookingRate: 43.7 },
      { label: "20 Jul", showRate: 69.4, bookingRate: 44.2 },
      { label: "25 Jul", showRate: 70.1, bookingRate: 45.1 },
      { label: "31 Jul", showRate: (67 / 96) * 100, bookingRate: (96 / 214) * 100 },
    ],
    acquisitionTrend: [
      { label: "1 Jul", spend: 0, attendedValue: 0, attended: 0, costPerAttended: 0, campaignReturn: 0, showRate: 0 },
      { label: "5 Jul", spend: 270, attendedValue: 900, attended: 6, costPerAttended: 45, campaignReturn: 3.3, showRate: 55.6 },
      { label: "10 Jul", spend: 590, attendedValue: 2100, attended: 13, costPerAttended: 45.4, campaignReturn: 3.6, showRate: 59.1 },
      { label: "15 Jul", spend: 930, attendedValue: 3650, attended: 22, costPerAttended: 42.3, campaignReturn: 3.9, showRate: 61.5 },
      { label: "20 Jul", spend: 1320, attendedValue: 5300, attended: 31, costPerAttended: 42.6, campaignReturn: 4, showRate: 62.9 },
      { label: "25 Jul", spend: 1690, attendedValue: 6900, attended: 40, costPerAttended: 42.3, campaignReturn: 4.1, showRate: 63.8 },
      { label: "31 Jul", spend: 2000, attendedValue: 8551, attended: 49, costPerAttended: 2000 / 49, campaignReturn: 8551 / 2000, showRate: (49 / 76) * 100 },
    ],
    campaigns: [
      { id: "whitening", name: "Whitening carousel", channel: "Instagram", format: "Carousel", delivery: "Active", spend: 520, enquiries: 148, booked: 24, attended: 8, value: 1184 },
      { id: "braces", name: "Braces reel", channel: "Instagram", format: "Reel", delivery: "Active", spend: 460, enquiries: 74, booked: 16, attended: 9, value: 1512 },
      { id: "implant", name: "Implant consultation video", channel: "Facebook", format: "Video", delivery: "Active", spend: 640, enquiries: 95, booked: 21, attended: 19, value: 4750 },
      { id: "checkup", name: "Check-up reminder post", channel: "Facebook", format: "Static post", delivery: "Paused", spend: 380, enquiries: 93, booked: 15, attended: 13, value: 1105 },
    ],
  },
};

export const INSIGHT_PERIODS = PERIODS;
export const INSIGHT_PERIOD_ORDER = ["day", "week", "month"];
export const DEFAULT_INSIGHT_PERIOD = "month";

// Extra sample aggregates used by the dashboard widgets. These are kept
// separate from the operational seed records because the Insights periods are
// reporting snapshots rather than the small set of live records in the demo.
export const INSIGHT_WIDGET_DATA = {
  day: {
    cohorts: {
      newCount: 4,
      returningCount: 4,
      services: [
        { id: "s-cardio", service: "Cardiology", newCustomers: 2, returningCustomers: 1 },
        { id: "s-derma", service: "Dermatology", newCustomers: 1, returningCustomers: 1 },
        { id: "s-holter", service: "Holter", newCustomers: 1, returningCustomers: 0 },
        { id: "s-thyroid", service: "Thyroid", newCustomers: 0, returningCustomers: 1 },
        { id: "s-ecg", service: "ECG", newCustomers: 0, returningCustomers: 1 },
        { id: "s-blood", service: "Blood tests", newCustomers: 0, returningCustomers: 0 },
      ],
    },
    channels: [
      { channel: "WhatsApp", enquiries: 3, bookings: 2, attendedValue: 240 },
      { channel: "Instagram", enquiries: 3, bookings: 1, attendedValue: 111 },
      { channel: "Messenger", enquiries: 1, bookings: 1, attendedValue: 120 },
      { channel: "Referral", enquiries: 1, bookings: 0, attendedValue: 0 },
    ],
    busyHours: [
      { hour: "10:00", starts: 1 }, { hour: "11:00", starts: 1 }, { hour: "12:00", starts: 0 },
      { hour: "13:00", starts: 0 }, { hour: "14:00", starts: 1 }, { hour: "15:00", starts: 0 },
      { hour: "16:00", starts: 1 }, { hour: "17:00", starts: 0 }, { hour: "18:00", starts: 0 },
    ],
    eligibleDays: 1,
    averageValueTrend: [148, 153, 160, 158, 157],
  },
  week: {
    cohorts: {
      newCount: 22,
      returningCount: 29,
      services: [
        { id: "s-cardio", service: "Cardiology", newCustomers: 7, returningCustomers: 7 },
        { id: "s-derma", service: "Dermatology", newCustomers: 4, returningCustomers: 6 },
        { id: "s-holter", service: "Holter", newCustomers: 4, returningCustomers: 4 },
        { id: "s-thyroid", service: "Thyroid", newCustomers: 3, returningCustomers: 5 },
        { id: "s-ecg", service: "ECG", newCustomers: 2, returningCustomers: 3 },
        { id: "s-blood", service: "Blood tests", newCustomers: 2, returningCustomers: 4 },
      ],
    },
    channels: [
      { channel: "WhatsApp", enquiries: 19, bookings: 9, attendedValue: 1200 },
      { channel: "Instagram", enquiries: 17, bookings: 7, attendedValue: 700 },
      { channel: "Messenger", enquiries: 9, bookings: 4, attendedValue: 400 },
      { channel: "Referral", enquiries: 6, bookings: 2, attendedValue: 212 },
    ],
    busyHours: [
      { hour: "10:00", starts: 0.55 }, { hour: "11:00", starts: 0.72 }, { hour: "12:00", starts: 0.45 },
      { hour: "13:00", starts: 0.30 }, { hour: "14:00", starts: 0.40 }, { hour: "15:00", starts: 0.52 },
      { hour: "16:00", starts: 0.38 }, { hour: "17:00", starts: 0.22 }, { hour: "18:00", starts: 0.13 },
    ],
    eligibleDays: 6,
    averageValueTrend: [148, 151, 154, 150, 158, 156, 157],
  },
  month: {
    cohorts: {
      newCount: 88,
      returningCount: 126,
      services: [
        { id: "s-cardio", service: "Cardiology", newCustomers: 24, returningCustomers: 30 },
        { id: "s-derma", service: "Dermatology", newCustomers: 17, returningCustomers: 25 },
        { id: "s-holter", service: "Holter", newCustomers: 14, returningCustomers: 15 },
        { id: "s-thyroid", service: "Thyroid", newCustomers: 12, returningCustomers: 23 },
        { id: "s-ecg", service: "ECG", newCustomers: 10, returningCustomers: 16 },
        { id: "s-blood", service: "Blood tests", newCustomers: 11, returningCustomers: 17 },
      ],
    },
    channels: [
      { channel: "WhatsApp", enquiries: 78, bookings: 40, attendedValue: 4100 },
      { channel: "Instagram", enquiries: 72, bookings: 31, attendedValue: 3300 },
      { channel: "Messenger", enquiries: 42, bookings: 17, attendedValue: 1970 },
      { channel: "Referral", enquiries: 22, bookings: 8, attendedValue: 1161 },
    ],
    busyHours: [
      { hour: "10:00", starts: 0.58 }, { hour: "11:00", starts: 0.75 }, { hour: "12:00", starts: 0.48 },
      { hour: "13:00", starts: 0.31 }, { hour: "14:00", starts: 0.42 }, { hour: "15:00", starts: 0.50 },
      { hour: "16:00", starts: 0.36 }, { hour: "17:00", starts: 0.20 }, { hour: "18:00", starts: 0.09 },
    ],
    eligibleDays: 26,
    averageValueTrend: [144, 148, 152, 151, 155, 156, 157],
  },
};

export const SERVICE_CAPACITY_PERIODS = {
  day: [
    { id: "s-holter", service: "Holter monitoring", booked: 1, slots: 1 },
    { id: "s-cardio", service: "Cardiology consultation", booked: 1, slots: 2 },
    { id: "s-derma", service: "Dermatology consultation", booked: 1, slots: 2 },
    { id: "s-thyroid", service: "Thyroid ultrasound", booked: 1, slots: 2 },
    { id: "s-ecg", service: "ECG", booked: 0, slots: 2 },
    { id: "s-blood", service: "Blood test panel", booked: 0, slots: 3 },
  ],
  week: [
    { id: "s-holter", service: "Holter monitoring", booked: 4, slots: 6 },
    { id: "s-cardio", service: "Cardiology consultation", booked: 6, slots: 11 },
    { id: "s-derma", service: "Dermatology consultation", booked: 5, slots: 10 },
    { id: "s-thyroid", service: "Thyroid ultrasound", booked: 3, slots: 7 },
    { id: "s-ecg", service: "ECG", booked: 2, slots: 7 },
    { id: "s-blood", service: "Blood test panel", booked: 2, slots: 9 },
  ],
  month: [
    { id: "s-holter", service: "Holter monitoring", booked: 16, slots: 22 },
    { id: "s-cardio", service: "Cardiology consultation", booked: 26, slots: 45 },
    { id: "s-derma", service: "Dermatology consultation", booked: 20, slots: 39 },
    { id: "s-thyroid", service: "Thyroid ultrasound", booked: 14, slots: 31 },
    { id: "s-ecg", service: "ECG", booked: 11, slots: 32 },
    { id: "s-blood", service: "Blood test panel", booked: 9, slots: 38 },
  ],
};

export const LAST_DECISION = {
  date: "14 July 2026",
  title: "Saturday mornings opened",
  bookings: 19,
  attended: 14,
  visitValue: 1943,
  summary: "19 bookings, 14 attended, and ₾1,943 in attended visit value since the change.",
};
